/*global rlinkClient */
import op from 'rlink-collections/operations';
import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';



export default function reduceRouting (routing, {type, payload}) {

  switch (type) {
    case 'MOUNT_ROUTED_VIEW': {
      let {
        view,
        params,
        transition,
        content,
        scrollPosition,
      } = payload;
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['current', 'view'], op.set, view],
        [['current', 'params'], op.set, params],
        [['current', 'transition'], op.set, transition],
        [['current', 'mountedContent'], op.set, content],
        [['current', 'scrollPosition'], op.set, scrollPosition],
      ]);
    }
    case 'MOUNT_MODAL': {
      let {
        replace,
        nudgeOffset,
        content,
        transition,
        returnTransition,
        fullscreen,
        onClose,
        bindOnCloseToClassNames,
      } = payload;

      if (replace) {
        let idx = routing.modals.length - 1;

        return ROUTING_STATE_SHAPE.updateAt(routing, [
          [['modals', idx], op.set, {
            content,
            transition,
            fullscreen,
            returnTransition: routing.modals[idx].returnTransition,
            nudgeOffset: routing.modals[idx].nudgeOffset,
            onClose,
            bindOnCloseToClassNames,
          }],
        ]);
      } else {
        return ROUTING_STATE_SHAPE.updateAt(routing, [
          [['modals'], op.add, {
            content,
            transition,
            returnTransition,
            nudgeOffset,
            fullscreen,
            onClose,
            bindOnCloseToClassNames,
          }],
          [['nextTransition'], op.set, transition],
        ]);
      }
    }
    case 'POP_MODAL': {
      // @TODO: THIS IS NOT THE CORRECT WAY TO DO THIS
      // (THOUGH IT MAY, IN FACT, BE THE WORST WAY TO DO THIS)
      if (typeof rlinkClient !== 'undefined'
          && routing.modals.length === 1
          && routing.current.view === 'open-own-profile') {
        rlinkClient.executeGameFunction('closeNamedModal', ['PlayerProfile']);
      }
      if (routing.modals.length === 0) {
        throw new Error('No modals to close.');
      }

      let idx = routing.modals.length - 1;
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['nextTransition'], op.set, routing.modals[idx].returnTransition],
        [['modals', idx], op.rem, null],
      ]);
    }
    case 'CLOSE_ALL_MODALS': {
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['modals'], op.set, []],
      ]);
    }
    case 'MOUNT_FLYOUT': {
      let {name, content} = payload;
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['flyouts', name], op.set, content],
      ]);
    }
    case 'CLOSE_FLYOUT': {
      let {name} = payload;
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['flyouts', name], op.rem, null],
      ]);
    }
    case 'UPDATE_CONTENT_META_INDEX': {
      let contentMetaIndex = payload;
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['contentMetaIndex'], op.set, contentMetaIndex],
      ]);
    }
    case 'UPDATE_LOCALE_MESSAGES': {
      let {locale, messages} = payload;
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['messages', locale], op.set, messages],
      ]);
    }
    case 'INIT_ROUTE_DEFINITIONS': {
      let {routeDefinitions, routePatterns, routesByView} = payload;
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['routeDefinitions'], op.set, routeDefinitions],
        [['routePatterns'], op.set, routePatterns],
        [['routesByView'], op.set, routesByView],
        [['nextTransition'], op.set, ''],
      ]);
    }
    case 'INIT_BUILD_CONTEXT_CONSTANTS': {
      let {defaultLocale, defaultRegion, useLongCaches, useLiveSafetyFeatures, contentRoot} = payload;
      return ROUTING_STATE_SHAPE.updateAt(routing, [
        [['defaultLocale'], op.set, defaultLocale],
        [['defaultRegion'], op.set, defaultRegion],
        [['useLongCaches'], op.set, useLongCaches],
        [['useLiveSafetyFeatures'], op.set, useLiveSafetyFeatures],
        [['contentRoot'], op.set, contentRoot],
      ]);
    }

  }
  return routing;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/reduceRouting.js